import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { createPurchaseInvoiceLineAsync, deletePurchaseInvoiceLineAsync, getAllArticalsAsync, getAllPurchaseInvoiceLineByIdAsync, getArticalByIdAsync, getPurchaseInvoiceLineByIdAsync, getWorkOrdersListWithClientAsync, updatePurchaseInvoiceLineAsync } from './purchaseInvoiceLineThunk';
const initialState = {
    status: APIStatus.IDLE,
};
export const purchaseInvoiceLineSlice = createSlice({
    name: 'purchaseinvoiceline',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllArticalsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllArticalsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.Articles = action.payload;
            state.ArticlesDropDown = action.payload.map((article) => {
                return {
                    label: `${article.articleNumber + ' - ' + article.name}`,
                    value: article.id
                };
            });
        })
            .addCase(getAllArticalsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getArticalByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getArticalByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.Article = action.payload;
        })
            .addCase(getArticalByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getWorkOrdersListWithClientAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getWorkOrdersListWithClientAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.WorkOrderListWithClientOptions = action.payload.map((workOrder) => {
                return {
                    label: workOrder.workOrderNumber,
                    value: workOrder.id
                };
            });
        })
            .addCase(getWorkOrdersListWithClientAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createPurchaseInvoiceLineAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createPurchaseInvoiceLineAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.purchaseInvoiceLine = action.payload;
        })
            .addCase(createPurchaseInvoiceLineAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updatePurchaseInvoiceLineAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updatePurchaseInvoiceLineAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.updatePurchaseInvoiceLine = action.payload;
        })
            .addCase(updatePurchaseInvoiceLineAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllPurchaseInvoiceLineByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllPurchaseInvoiceLineByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.purchaseInvoiceLines = action.payload;
        })
            .addCase(getAllPurchaseInvoiceLineByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getPurchaseInvoiceLineByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getPurchaseInvoiceLineByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.purchaseInvoiceLine = action.payload;
        })
            .addCase(getPurchaseInvoiceLineByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deletePurchaseInvoiceLineAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deletePurchaseInvoiceLineAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(deletePurchaseInvoiceLineAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default purchaseInvoiceLineSlice.reducer;
